"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "table-list-clients-component"
  }, [_vm.list && _vm.list.length > 0 ? _c("div", [_c("div", {
    staticClass: "list-itens-informations"
  }, [!_vm.isMobile ? _c("div", {
    staticClass: "header"
  }, [_c("div", {
    staticClass: "one"
  }, [_vm._v("Nome")]), _vm._v(" "), _c("div", {
    staticClass: "two"
  }, [_vm._v("Path")]), _vm._v(" "), _c("div", {
    staticClass: "three"
  }, [_vm._v("Icon")]), _vm._v(" "), _c("div", {
    staticClass: "four"
  }, [_vm._v("Ativa")]), _vm._v(" "), _c("div", {
    staticClass: "five"
  }, [_vm._v("Opção Menu")])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.list, function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "body",
      on: {
        click: function click($event) {
          return _vm.actionItem(item);
        }
      }
    }, [_c("div", {
      staticClass: "one"
    }, [_vm.isMobile ? _c("span", [_vm._v("Nome: ")]) : _vm._e(), _vm._v(_vm._s(item.name) + "\n        ")]), _vm._v(" "), _c("div", {
      staticClass: "one"
    }, [_vm.isMobile ? _c("span", [_vm._v("Path: ")]) : _vm._e(), _vm._v(_vm._s(item.path) + "\n        ")]), _vm._v(" "), _c("div", {
      staticClass: "two"
    }, [_vm.isMobile ? _c("span", [_vm._v("Icon: ")]) : _vm._e(), _vm._v(_vm._s(item.icon) + "\n        ")]), _vm._v(" "), _c("div", {
      staticClass: "three"
    }, [_vm.isMobile ? _c("span", [_vm._v("Ativa: ")]) : _vm._e(), _vm._v(_vm._s(item.active) + "\n        ")]), _vm._v(" "), _c("div", {
      staticClass: "four"
    }, [_vm.isMobile ? _c("span", [_vm._v("Opção Menu: ")]) : _vm._e(), _vm._v(_vm._s(item.menuOption || "") + "\n        ")])]);
  })], 2)]) : _vm._e(), _vm._v(" "), !_vm.list || !_vm.list.length ? _c("div", [_c("h1", {
    staticClass: "empty-title"
  }, [_vm._v("\n      Sem dados no momento\n    ")])]) : _vm._e()]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;